import { render, staticRenderFns } from "./ClientOrderHome.vue?vue&type=template&id=db2c5160&scoped=true"
import script from "./ClientOrderHome.vue?vue&type=script&lang=js"
export * from "./ClientOrderHome.vue?vue&type=script&lang=js"
import style0 from "./ClientOrderHome.vue?vue&type=style&index=0&id=db2c5160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2c5160",
  null
  
)

export default component.exports